var render, staticRenderFns
import script from "./mixins-items-arrow-keys.vue?vue&type=script&lang=js"
export * from "./mixins-items-arrow-keys.vue?vue&type=script&lang=js"
import style0 from "./mixins-items-arrow-keys.vue?vue&type=style&index=0&id=6ceb2ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceb2ce8",
  null
  
)

export default component.exports